import { isAPIError, get } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { urls } from '../constants'
import type { Actions } from '../state'
import { fetchTrackingCallDetailsActionCreator } from '../state'
import type { ENTITY_TYPES } from '@sales-center/common'

export async function fetchCallTrackingDetailsEffect(
  type: ENTITY_TYPES,
  id: number,
): Promise<Actions> {
  const response = await get(urls.fetchCallTrackingDetails(type, id))
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to create Activity')
    }

    return fetchTrackingCallDetailsActionCreator({
      entityCallTrackingSystemFields: null,
      isCallTrackingEnabled: false,
      isProcessing: false,
    })
  }

  return fetchTrackingCallDetailsActionCreator(result)
}
